
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.4485 4.16119C13.0963 3.34974 12.5922 2.62115 11.9502 1.99566C11.3083 1.37016 10.5606 0.878978 9.72786 0.535756C8.86531 0.180257 7.9495 0 7.00586 0C6.06222 0 5.1464 0.180257 4.28386 0.535738C3.45111 0.878959 2.7034 1.37014 2.06148 1.99564C1.41956 2.62115 0.915482 3.34974 0.56325 4.16117C0.198417 5.00166 0.0134277 5.89405 0.0134277 6.81355C0.0134277 7.73305 0.198417 8.62543 0.563231 9.46592C0.915463 10.2774 1.41954 11.006 2.06146 11.6314C2.7034 12.257 3.45111 12.7481 4.28385 13.0913C5.1464 13.4468 6.06222 13.6271 7.00586 13.6271C7.9495 13.6271 8.86531 13.4469 9.72786 13.0913C10.5606 12.7481 11.3083 12.2569 11.9502 11.6314C12.5922 11.006 13.0963 10.2774 13.4485 9.46592C13.8133 8.62543 13.9983 7.73305 13.9983 6.81355C13.9983 5.89405 13.8133 5.00166 13.4485 4.16119ZM7.0059 2.21588C7.42386 2.21588 7.76266 2.54603 7.76266 2.95328V6.07617H11.1624C11.5803 6.07617 11.9191 6.40632 11.9191 6.81357C11.9191 7.22083 11.5803 7.55096 11.1624 7.55096H7.20077C7.16773 7.55096 7.13527 7.54868 7.10333 7.54468C7.07142 7.54868 7.03893 7.55096 7.0059 7.55096C6.58796 7.55096 6.24915 7.22083 6.24915 6.81357V2.95328C6.24915 2.54603 6.58796 2.21588 7.0059 2.21588Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'InProgress',
    }) as DefineComponent
    </script>
    